import {Layout} from '@docma-mm-core/layout/layout';
import {Project} from '@docma-mm-core/project/project';
import {FilterCriteria} from '@docma-mm-core/filter/filter-criteria';
import {LayoutSortItem} from '@docma-mm-core/layout/layout-sort-item';
import {Guid} from 'guid-typescript';

export interface FieldOrder {
  Field: {
    Id?: number;
  };
  Index: number;
  Pinned: boolean | 'left' | 'right' | undefined;
}

export class LayoutStateModel {

  constructor(init?: Partial<LayoutStateModel>) {
    if (init) {
      Object.assign(this, init);
    }
    this.id = Guid.create().toString();
  }
  id: string;
  project: Project;
  layout: Layout;
  filters: FilterCriteria[];
  searchFilters: FilterCriteria[];
  sortItems: LayoutSortItem[];
  userState: Layout;
  userColumnOrder?: FieldOrder[];
}
